<template>
  <BaseCustomizeMetal componentCode="R" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalR",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 67px;
    left: 118px;
    @include betweenTableTablePro {
      top: 38px;
      left: 68px;
    }
    @include table {
      top: 23px;
      left: 43px;
    }
    @include phone {
      top: 15px;
      left: 29px;
    }
  }
  .templeName {
    height: 28px;
    width: 223px;
    margin-bottom: 36px;
    .textContainer {
      width: 223px;
    }
  }
  .godName {
    width: 263px;
    height: 53px;
    .textContainer {
      width: 263px;
    }
  }
  .gift {
    width: 178px;
    height: 32px;
    margin: 0 17px auto auto;
    .textContainer {
      width: 178px;
    }
  }
  .respect {
    width: 46px;
    position: absolute;
    bottom: 3px;
    left: 15px;
  }
}
</style>
